import { memo } from "react";
import classNames from "classnames";
import { Modal, ModalProps } from "@tecorien/mimic";

import styles from "./styles.module.scss";

export type AresModalProps = ModalProps & {}

export const AresModal = memo<AresModalProps>(({ ...props }) => {
  return (
    <Modal
      {...props}
      className={classNames(props.className as string, styles.root)}
      buttonsClassName={classNames(props.buttonsClassName as string, styles.buttons)}
    />
  );
});

export default AresModal;